(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vielu-buy-bar"] && !Shopify.designMode) return;
  try {
    
  class VieluBuyBar extends HTMLElement {
    connectedCallback() {
      this.target = document.querySelector('form[action*="/cart/add"]');
      if (!this.target) return;
      this.querySelector('button').addEventListener('click', () => {
        this.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      this.observer = new IntersectionObserver(([entry]) => this.toggle(!entry.isIntersecting));
      this.observer.observe(this.target);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      document.body.classList.remove('vielu-buy-bar-visible');
    }

    toggle(visible) {
      this.hidden = !visible;
      document.body.classList.toggle('vielu-buy-bar-visible', visible);
    }
  }

  if (!customElements.get('vielu-buy-bar')) customElements.define('vielu-buy-bar', VieluBuyBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vielu-oferta"] && !Shopify.designMode) return;
  try {
    
  class VieluOferta extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end);
      this.wrapper = this.closest('.shopify-section');
      if (Number.isNaN(this.end)) {
        this.expire();
        return;
      }
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    expire() {
      clearInterval(this.interval);
      if (this.wrapper && !(window.Shopify && window.Shopify.designMode)) this.wrapper.hidden = true;
    }

    tick() {
      const left = Math.floor((this.end - Date.now()) / 1000);
      if (left <= 0) {
        this.expire();
        return;
      }
      const parts = {
        days: Math.floor(left / 86400),
        hours: Math.floor((left % 86400) / 3600),
        minutes: Math.floor((left % 3600) / 60),
        seconds: left % 60,
      };
      for (const [name, value] of Object.entries(parts)) {
        const el = this.querySelector(`[data-${name}]`);
        if (el) el.textContent = String(value).padStart(2, '0');
      }
    }
  }

  if (!customElements.get('vielu-oferta')) customElements.define('vielu-oferta', VieluOferta);

  } catch(e) { console.error(e); }
})();
})();
